import { createDictionaryApiFactory, mapDictionaryState } from "./dictionaryApiFactory";
import { fetchApi } from "../../../../lib/fetchApi";
import { SelectItemDto } from "../../../../types/SelectItemDto";

export const mapToClaimReopenReason = mapDictionaryState;

const functionalAreasApi = createDictionaryApiFactory("functionalAreas");

export const getFunctionalAreas = functionalAreasApi.search;
export const getFunctionalAreasDetail = functionalAreasApi.getDetail;
export const exportCsvFunctionalAreas = functionalAreasApi.exportCsv;

export const getFunctionalAreaSelect = async (): Promise<SelectItemDto[]> => {
    const response = await fetchApi.get(`/functionalAreas/select`) as SelectItemDto[];
    return response;
}